<script setup>
import ClickableCell from '@/components/lists/ClickableCell';
// Props
const props = defineProps({
  league: {
    type: Object,
    default: () => null
  }
});
</script>

<template>
  <clickable-cell
      icon="mdi-table"
      tone="league"
      class="mb-3"
      :to="{ name: 'LeagueDetail', params: { leagueId: props.league.id } }"
      :title="league.name"
      :subtitle="league.teamCount + ' competitors'"
  />
</template>
